import React, { useState } from 'react';
import { CreateFormFeatureDialog } from 'components';
import { CreateStepFormData } from '../components/step-form-helper';
import { PIPELINES_AND_STEPS_PATHS } from 'constants/pipelines-and-steps-paths';
import { useNavigate } from 'react-router-dom';
import { createFieldMappingStyles } from '../createFieldMapping/field-mapping-form-helper';
import { createPipelineStyles as createFormFeatureStyles } from 'pages/pipelines/CreateOrUpdatePipeline/create-or-update-pipeline-helper';
import {
    createJavascriptTransformConfig,
    CreateJavascriptTransformDefaults,
    CreateJavascriptTransformSchema,
    JavascriptTransformFormValues,
} from './create-javascript-transform-form-helper';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { JavascriptTransformForm } from '../components';
import { useAuth } from 'core/contexts';
import { PostJSTransformStepProps, useCreateJSTransform } from 'hooks';
import { JAVASCRIPT_TRANSFORM } from 'pages/pipelines/pipelines-helper';

export const CreateJavascriptTransformForm = ({
    stepData,
    onModalClose,
}: {
    stepData?: CreateStepFormData;
    onModalClose: () => void;
}): React.JSX.Element => {
    const { getToken } = useAuth();
    const navigate = useNavigate();
    const {
        control,
        watch,
        setValue,
        clearErrors,
        handleSubmit,
        setError,
        formState: { errors },
    } = useForm<JavascriptTransformFormValues>({
        mode: 'all',
        resolver: yupResolver(CreateJavascriptTransformSchema),
        defaultValues: CreateJavascriptTransformDefaults,
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { mutate: createJavascriptTransformStep } = useCreateJSTransform();

    const handleBackButtonClick = (): void => {
        onModalClose?.();
    };

    const handleCloseButtonClick = (): void => {
        navigate(PIPELINES_AND_STEPS_PATHS.LANDING_PAGE);
    };

    const onSubmit = (data: any): void => {
        if (!data) return;
        setIsLoading(true);

        const postData: PostJSTransformStepProps = {
            name: stepData?.name ?? '',
            description: stepData?.description ?? '',
            funcName: data.funcName,
            jsBase64: btoa(data.jsBase64),
        };
        createJavascriptTransformStep(
            {
                postData,
                token: getToken(),
            },
            {
                onSuccess: (result: any) => {
                    setIsLoading(false);
                    const path =
                        PIPELINES_AND_STEPS_PATHS.UPDATE_STEP_DETAILS.replace(
                            ':id',
                            result.data.id
                        );
                    const query = `?option=${JAVASCRIPT_TRANSFORM}`;

                    navigate(`${path}${query}`);
                },
                onError: () => {
                    setIsLoading(false);
                },
            }
        );
    };

    return (
        <CreateFormFeatureDialog
            buttonText='Save'
            isLoading={isLoading}
            handleSubmit={handleSubmit(onSubmit)}
            handleCloseButton={handleCloseButtonClick}
            handleBackButton={handleBackButtonClick}
            listConfig={createJavascriptTransformConfig}
            isOpenInModal={true}
            customStyles={createFormFeatureStyles.root}
            customButtonContainerStyles={
                createFieldMappingStyles.formFeatureNextButtonStyles
            }
        >
            <JavascriptTransformForm
                control={control}
                errors={errors}
                watch={watch}
                setValue={setValue}
                clearErrors={clearErrors}
                setError={setError}
            />
        </CreateFormFeatureDialog>
    );
};
